import React from "react";
import { Box, Flex, Text } from "theme-ui";

const TradeRow = ({ trade, colorMode }: any) => {
    const { name, total, done, inProgress, onHold } = trade;

    const donePct = (done / total) * 100;
    const inProgPct = (inProgress / total) * 100;
    const onHoldPct = (onHold / total) * 100;

    return (
        <Box sx={{ my: 1 }}>
            {/* Title row */}
            <Flex
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 0.5,
                }}
            >
                <Text sx={{ fontWeight: 500, fontSize: ["10px", "12px"], color: colorMode === 'light' ? '#453521' : '#a9a9a9' }}>{name}:</Text>
                <Text sx={{ fontWeight: 500, fontSize: ["10px", "12px"], color: colorMode === 'light' ? '#453521' : '#a9a9a9' }}>{total}</Text>
            </Flex>

            {/* Segmented progress bar */}
            <Box
                sx={{
                    bg: "#eee",
                    borderRadius: "10PX",
                    overflow: "hidden",
                    height: "16px",
                    mb: 0.5,
                }}
            >
                <Flex sx={{ width: "100%", height: "100%" }}>
                    <Box
                        sx={{
                            width: `${donePct}%`,
                            bg: "rgba(180, 207, 114, 1)",
                        }}
                    />
                    <Box
                        sx={{
                            width: `${inProgPct}%`,
                            bg: "rgba(255, 160, 96, 1)",
                        }}
                    />
                    <Box
                        sx={{
                            width: `${onHoldPct}%`,
                            bg: "rgba(234, 95, 95, 1)",
                        }}
                    />
                </Flex>
            </Box>

            {/* Labels below bar */}
            <Flex
                sx={{
                    fontWeight: 500,
                    justifyContent: "space-between",
                    fontSize: ["8px", "10px",],
                    color: "rgba(141, 141, 141, 1)",
                }}
            >
                <Text>Done: {done}</Text>
                <Text>In Progress: {inProgress}</Text>
                <Text>On Hold: {onHold}</Text>
            </Flex>
        </Box>
    );
};

export default React.memo(TradeRow)